import { createReducer } from 'typesafe-actions';
import {
    ADD_COUPON_EVENT,
    COPY_EVENT_TO_COUPON_TYPE,
    couponType,
    getMarketLimitAsync,
    MOVE_EVENT_TO_COUPON_TYPE,
    NEED_CONFIRM_COUPON_EVENT,
    REMOVE_ALL_COUPON_EVENTS,
    REMOVE_COUPON_EVENT,
    REMOVE_NEED_CONFIRM_COUPON_EVENT,
    REPLACE_COUPON_EVENTS,
    saveCoupon, SET_COUPON_STATE,
    SET_CURRENT_COUPON_TYPE,
    SET_RATE_COUPON,
    SET_RATE_COUPON_EVENT,
    TOGGLE_ACTIVE_STATUS_COUPON_EVENT,
    UPDATE_COUPON_MESSAGE,
    UPDATE_COUPON_TRANSFER_MESSAGE
} from '../actions';
import {
    EventForm,
    FixtureElement,
    MarketElement,
    MarketLimit,
    SelectionElement
} from '../../../models/api/codegen/code';

const initialCouponState: CouponState = {
    ORDINAR: [],
    EXPRESS: [],
    SYSTEM: [],
    currentCouponType: 'ORDINAR',
    oddsChanged: false,
    message: '',
    transferMessage: false,
    rate: {
        SYSTEM: 0,
        EXPRESS: 0,
        ORDINAR: 0
    }
};

export const coupons = createReducer<CouponState>(initialCouponState)
    .handleAction(
        REPLACE_COUPON_EVENTS,
        (couponState: CouponState, action: { payload: CouponEvent[] }) => {
            let currentEvents: CouponEvent[] =
                couponState[couponState.currentCouponType];
            const newEvents: CouponEvent[] = action.payload;
            if (currentEvents.length === 0 || newEvents.length === 0) {
                return couponState;
            }
            const ids: number[] = newEvents.map(e => e.selectionId);
            const replaceIfMatch = (current: CouponEvent): CouponEvent => {
                if (ids.indexOf(current.selectionId) > -1) {
                    return (
                        newEvents.find(
                            ne => ne.selectionId === current.selectionId
                        ) || current
                    );
                }
                return current;
            };
            currentEvents = currentEvents.map(replaceIfMatch);
            return {
                ...couponState,
                [couponState.currentCouponType]: currentEvents
            };
        }
    )
    .handleAction(
        ADD_COUPON_EVENT,
        (couponState: CouponState, action: { payload: CouponEvent }) => {
            const {
                fixtureId,
                marketName,
                marketId,
                selectionId,
                odds,
                selectionName,
                rate,
                competitionName,
                minRate,
                maxRate,
                live
            } = action.payload;
            const currentCouponEvents: CouponEvent[] = couponState[couponState.currentCouponType];

            // Проверка на дубликат события (точно такое же событие уже добавлено)
            if (currentCouponEvents.filter(cEvent => cEvent.selectionId === selectionId).length) {
                return {
                    ...couponState,
                    message: 'coupons.alreadyExistMessage'
                };
            }

            // Проверка на события из одного матча (нельзя добавлять несколько событий из одного матча)
            const eventFromSameFixture: CouponEvent | undefined = currentCouponEvents
                .find(cEvent => cEvent.fixtureId === fixtureId);
            if (eventFromSameFixture) {
                return {
                    ...couponState,
                    message: 'coupons.alreadyExistFixtureMessage'
                };
            }

            const addedEvent: CouponEvent = {
                fixtureId,
                active: true,
                odds,
                rate,
                selectionId,
                competitionName,
                selectionName,
                marketName,
                marketId,
                minRate,
                maxRate,
                live,
            };
            // если добавляется второй шаг в ординар, то переносим оба в экспресс и показываем сообщение
            if (couponState.currentCouponType === 'ORDINAR') {
                const ordinarEvents: CouponEvent[] = currentCouponEvents;
                const expressEvents: CouponEvent[] = couponState['EXPRESS'];
                if (ordinarEvents.length === 1 && expressEvents.length === 0) {
                    return {
                        ...couponState,
                        ORDINAR: [],
                        EXPRESS: [...ordinarEvents, addedEvent],
                        currentCouponType: 'EXPRESS',
                        transferMessage: true
                    }
                }
            }

            return {
                ...couponState,
                [couponState.currentCouponType]: [
                    ...currentCouponEvents,
                    addedEvent
                ],
                rate: {
                    ...couponState.rate,
                    [couponState.currentCouponType]: rate
                }
            };
        }
    )
    .handleAction(
        NEED_CONFIRM_COUPON_EVENT,
        (couponState: CouponState, action: { payload: CouponEvent }) => {
            console.log(`added event to temp, waiting confirm by user`);
            return { ...couponState, needConfirmEvent: action.payload };
        }
    )
    .handleAction(
        REMOVE_NEED_CONFIRM_COUPON_EVENT,
        (couponState: CouponState) => {
            console.log(`remove tmp event from redux state...`);
            return { ...couponState, needConfirmEvent: undefined };
        }
    )
    .handleAction(
        UPDATE_COUPON_MESSAGE,
        (couponState: CouponState, action: { payload: string }) => {
            return { ...couponState, message: action.payload };
        }
    )
    .handleAction(
        UPDATE_COUPON_TRANSFER_MESSAGE,
        (couponState: CouponState, action: { payload: boolean }) => {
            return { ...couponState, transferMessage: action.payload };
        }
    )
    .handleAction(
        REMOVE_COUPON_EVENT,
        (couponState: CouponState, action: { payload: CouponEvent }) => {
            const { selectionId } = action.payload;
            const couponEvents: CouponEvent[] = couponState[couponState.currentCouponType];
            return {
                ...couponState,
                [couponState.currentCouponType]: couponEvents.filter(
                    event => event.selectionId !== selectionId
                )
            };
        }
    )
    .handleAction(
        REMOVE_ALL_COUPON_EVENTS,
        (couponState: CouponState, action: { payload: CouponEvent }) => {
            return { ...couponState, [couponState.currentCouponType]: [] };
        }
    )
    .handleAction(
        TOGGLE_ACTIVE_STATUS_COUPON_EVENT,
        (couponState: CouponState, action: { payload: CouponEvent }) => {
            const { selectionId } = action.payload;
            const couponEvents: CouponEvent[] = couponState[couponState.currentCouponType];
            const toggledCouponEvents: CouponEvent[] = couponEvents.map(event =>
                event.selectionId === selectionId
                    ? {
                          ...event,
                          active: !event.active
                      }
                    : event
            );
            return {
                ...couponState,
                [couponState.currentCouponType]: toggledCouponEvents
            };
        }
    )
    .handleAction(
        SET_CURRENT_COUPON_TYPE,
        (couponState: CouponState, action: { payload: couponType }) => {
            return { ...couponState, currentCouponType: action.payload };
        }
    )
    .handleAction(
        MOVE_EVENT_TO_COUPON_TYPE,
        (
            couponState: CouponState,
            action: { payload: { fixtureId: number, selectionId: number; toType: couponType } }
        ) => {
            const { fixtureId, selectionId, toType } = action.payload;
            const movedCouponEvent: CouponEvent | undefined = couponState[couponState.currentCouponType]
                .find(el => el.selectionId === selectionId);
            if (movedCouponEvent) {
                if (couponState[toType].find(el => el.selectionId === selectionId)) {
                    console.log(`Event with selectionId '${selectionId}' already exist at coupon type '${toType}'`);
                    return { ...couponState, message: 'coupons.alreadyExist' };
                }
                const eventFromSameFixture: CouponEvent | undefined = couponState[toType].find(
                    cEvent => cEvent.fixtureId === fixtureId
                );
                if (eventFromSameFixture) {
                    return {
                        ...couponState,
                        message: 'coupons.alreadyExistFixtureMessage'
                    };
                }
                return {
                    ...couponState,
                    [toType]: [...couponState[toType], movedCouponEvent],
                    [couponState.currentCouponType]: couponState[
                        couponState.currentCouponType
                    ].filter(el => el.selectionId !== selectionId)
                };
            } else {
                return couponState;
            }
        }
    )
    .handleAction(
        COPY_EVENT_TO_COUPON_TYPE,
        (
            couponState: CouponState,
            action: { payload: { fixtureId: number, selectionId: number; toType: couponType } }
        ) => {
            const { fixtureId, selectionId, toType } = action.payload;
            const copiedCouponEvent: CouponEvent | undefined = couponState[
                couponState.currentCouponType
            ].find(el => el.selectionId === selectionId);
            if (copiedCouponEvent) {
                if (couponState[toType].find(el => el.selectionId === selectionId)) {
                    console.log(`Event with selectionId '${selectionId}' already exist at coupon type '${toType}'`);
                    return { ...couponState, message: 'coupons.alreadyExist' };
                }
                const eventFromSameFixture: CouponEvent | undefined = couponState[toType].find(
                    cEvent => cEvent.fixtureId === fixtureId
                );
                if (eventFromSameFixture) {
                    return {
                        ...couponState,
                        message: 'coupons.alreadyExistFixtureMessage'
                    };
                }
                return {
                    ...couponState,
                    [toType]: [...couponState[toType], copiedCouponEvent]
                };
            } else {
                return couponState;
            }
        }
    )
    .handleAction(
        SET_RATE_COUPON_EVENT,
        (
            couponState: CouponState,
            action: { payload: { selectionId: number; rate: number } }
        ) => {
            const { selectionId, rate } = action.payload;
            return {
                ...couponState,
                [couponState.currentCouponType]: couponState[
                    couponState.currentCouponType
                ].map(el =>
                    el.selectionId === selectionId
                        ? {
                              ...el,
                              rate: rate
                          }
                        : el
                ),
                rate: {
                    ...couponState.rate,
                    [couponState.currentCouponType]: rate
                }
            };
        }
    )
    .handleAction(
        SET_RATE_COUPON,
        (couponState: CouponState, action: { payload: { rate: number } }) => {
            const { rate } = action.payload;
            const newRate: CouponState['rate'] = {
                ...couponState.rate,
                [couponState.currentCouponType]: rate
            };
            return { ...couponState, rate: newRate };
        }
    )
    .handleAction(saveCoupon.success, (state: CouponState, action) => {
        return {
            ...state,
            [state.currentCouponType]: state[state.currentCouponType].filter(
                couponEvent => couponEvent.active === false
            )
        };
    })
    .handleAction(
        saveCoupon.failure,
        (
            state: CouponState,
            action: { payload: { response: { body: { message: string } } } }
        ) => {
            const {
                payload: {
                    response: {
                        body: { message }
                    }
                }
            } = action;
            return { ...state, message };
        }
    )
    .handleAction(
        getMarketLimitAsync.success,
        (state: CouponState, { payload }: { payload: MarketLimit }) => {
            const current: CouponState['currentCouponType'] = state.currentCouponType;
            const updateRate = (rate?: number): number => {
                let newRate: number = !rate ? 0 : rate;
                if (current !== 'ORDINAR' || newRate === 0) {
                    return newRate;
                }
                const checkLimit = (limit?: number) => limit && limit > 0;
                if (
                    checkLimit(payload.maxPoints) &&
                    newRate > payload.maxPoints
                ) {
                    return payload.maxPoints;
                } else if (
                    checkLimit(payload.minPoints) &&
                    newRate < payload.minPoints
                ) {
                    return payload.minPoints;
                } else {
                    return newRate;
                }
            };
            return {
                ...state,
                [current]: state[current].map(ce =>
                    ce.marketId === Number(payload.marketId)
                        ? {
                              ...ce,
                              minRate: payload.minPoints,
                              maxRate: payload.maxPoints,
                              rate: updateRate(ce.rate)
                          }
                        : ce
                )
            };
        }
    )
    .handleAction(SET_COUPON_STATE, (state, action: {payload: CouponState}) => {
        console.log(new Date(), '[COUPON WS] SET COUPON STATE', action.payload)
        return action.payload;
    });

export const isLoadingCoupons = createReducer(false)
    .handleAction(saveCoupon.request, () => true)
    .handleAction(saveCoupon.failure, () => false)
    .handleAction(saveCoupon.success, () => false);

export const isGetLimits = createReducer(false)
    .handleAction(getMarketLimitAsync.request, () => true)
    .handleAction(getMarketLimitAsync.failure, () => false)
    .handleAction(getMarketLimitAsync.success, () => false);

export interface CouponEvent extends EventForm {
    fixtureId: number;
    selectionId: number;
    marketId: number;
    direction?: 'up' | 'down';
    odds: number;
    competitionName: FixtureElement['cn'];
    selectionName: MarketElement['n'];
    marketName: SelectionElement['n'];
    minRate?: number;
    maxRate?: number;
    live: boolean;
}

export type CouponState = {
    ORDINAR: CouponEvent[];
    EXPRESS: CouponEvent[];
    SYSTEM: CouponEvent[];
    currentCouponType: couponType;
    oddsChanged: boolean;
    message: string;
    transferMessage: boolean;
    rate: {
        EXPRESS: number;
        SYSTEM: number;
        ORDINAR: number;
    };
    needConfirmEvent?: CouponEvent;
};
